<template>
  <div class="item">
    <div class="ind-cab">
      <span class="ind-cab-text">{{ cab }}</span>
    </div>
    <div class="ind-content">
      <span class="ind-content-text">{{ text }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["cab", "text"],
};
</script>
<style>
.item {
  padding: 0.3rem 0;
  display: flex;
}
.ind-cab {
  background-color: #efefef;
  width: 30%;
  align-content: center;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}
.ind-cab-text {
  color: #24C6AB;
  padding: 0.4rem;
  font-size: 0.9rem;
  font-weight: 600;
}
.ind-content {
  border: 1px solid #ddd;
  width: 70%;
  padding: 0 0.3rem; 
  align-content: center;
}
.ind-content-text {
  font-size: 0.9rem;
  /* font-weight: bold; */
}
</style>
